<template>
  <div class="row" style="margin:0 2%">
    <table class="table">
      <td style="width:30%;"/>
      <td style="padding:30px 0 0 0">
        <div class="progress">
          <div :aria-valuenow="currentSectionIndex"
               :aria-valuemax="countSections"
               :style="progressBarWidth"
               class="progress-bar"
               role="progressbar"
               aria-valuemin="0">
            <small class="justify-content-center d-flex  w-100">
              {{ (currentSectionIndex + 1) + ' / ' + countSections }}
            </small>
          </div>
        </div>
        <button class="btn btn-lg btn-outline-primary" @click="validateSection(0)">
          {{ $t('evaluations.head.button.previous') }}
        </button>
        <button class="btn btn-lg btn-outline-primary" @click="validateSection(1)">
          {{ $t('evaluations.head.button.next') }}
        </button>

        <b-modal ref="warningSnapshotModal"
                 :title="$t('error_alert_title')"
                 ok-variant="warning"
                 centered
                 @cancel.prevent="closeWarningSnapshotModal()"
                 @ok.prevent="okWarningSnapshotModal()">
          <p class="text-warning">{{ $t('evaluation.form_not_full') }}</p>
        </b-modal>
        <!--
        <button class="btn btn-lg btn-outline-primary" @click="validate">
          {{ $t('evaluations.head.button.validate') }}
        </button>
        -->
      </td>
    </table>
    <!-- Content -->
    <table class="table">

      <EvaluationSection
        v-for="(section, key) in entries[0]['children']"
        v-show="currentSection == section"
        ref="evaluation_sections"
        :key="key"
        :evaluation_title="evaluation.title"
        :section="section"
      />

    </table>
    <hr>
    <div v-if="this.apend_s1" class="comSize">
     * L’activité principale fait référence à un ou des loisirs, un travail bénévole ou rémunéré, une occupation, des
      hobbies ou une fonction qui occupent la majorité de votre temps. Le lieu d’activité principale réfère à l’endroit
      ou vous réalisez votre ou vos activités principales. Il peut donc être chez vous ou à l’extérieur du domicile
      dépendamment de l'activité en question.
    </div>
    <div v-if="this.apend_s9" class="comSize">
      * L’activité principale fait référence à un ou des loisirs, un travail bénévole ou rémunéré, une occupation, des
      hobbies ou une fonction qui occupent la majorité de votre temps. Le lieu d’activité principale réfère à l’endroit
      ou vous réalisez votre ou vos activités principales. Il peut donc être chez vous ou à l’extérieur du domicile
        dépendamment de l'activité en question.
    </div>
    <table class="table">
      <td style="width:30%;"/>
      <td style="padding:30px 0 0 0">
        <div style="margin-bottom: 15px">

          <button class="btn btn-lg btn-outline-primary" @click="validateSection(0)">
            {{ $t('evaluations.head.button.previous') }}
          </button>
          <button class="btn btn-lg btn-outline-primary" @click="validateSection(1)">
            {{ $t('evaluations.head.button.next') }}
          </button>
          <b-modal ref="warningSnapshotModal"
                   :title="$t('error_alert_title')"
                   ok-variant="warning"
                   centered
                   @cancel.prevent="closeWarningSnapshotModal()"
                   @ok.prevent="okWarningSnapshotModal()">
            <p class="text-warning">{{ $t('evaluation.form_not_full') }}</p>
          </b-modal>

          <p class="float-center position-link"><a href="https://autonomia.care/politique-de-confidentialit%C3%A9" target='_blank'>Accéder à la page politique de confidentialité</a></p>
     <button v-if="this.apend_btn"  class="btn btn-lg btn-outline-primary float-right position-btn"  @click="c2method">
            {{ $t('save_as') }}
         </button>
          <button v-if="!this.apend_btn"  class="btn btn-lg btn-outline-primary float-right position-btn"  @click="c2method">
            Enregistrer jusqu'ici
          </button>

        </div>
        <SaveSnapshotModal ref="saveSnapshotModal"  @saved="c2method" />
        <div class="progress">
          <div :aria-valuenow="currentSectionIndex"
               :aria-valuemax="countSections"
               :style="progressBarWidth"
               class="progress-bar"
               role="progressbar"
               aria-valuemin="0">
            <small class="justify-content-center d-flex w-100">
              {{ (currentSectionIndex + 1) + ' / ' + countSections }}
            </small>
          </div>
        </div>
      </td>
    </table>

    <!-- Modals -->
    <b-modal ref="sectionNotFull"
             :title="$t('error_alert_title')"
             ok-variant="danger"
             ok-cancel
             centered
             @ok.prevent="changeSection()"
             @cancel.prevent="closeModalSectionNotFull()">
      <p class="text-danger">{{ $t('evaluation.section_not_full') }}</p>
    </b-modal>

  </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import EvaluationSection from './evaluation/EvaluationSection'
import SaveSnapshotModal from './evaluation/SaveSnapshotModal'
import Evaluations from './Evaluations'
import Form from "vform";

export default {
  name: 'EvaluationX',
  components: {EvaluationSection , SaveSnapshotModal ,Evaluations},
  props: {
    evaluation: {
      type: Object,
      required: true
    },
    apend_s1: false,
    apend_s9: false,
    apend_btn:false

  },

  data: () => ({
    id: 0,
    selection: null,
    selected: null,
    currentSectionIndex: 0,
    entries: [],
    latestClick: 0,
    savingNew: false,
    click:false,
    form: new Form({
      title: new Date().toJSON().slice(0, 10).split('-').reverse().join('/'),

    }),
  }),


  computed: {
    color() {
      return this.evaluation.color
    },

    data() {
      return this.evaluation.data
    },

    defaultValue() {
      return this.evaluation.defaultValue
    },

    description() {
      return `evaluations.${this.evaluation.title}.descriptions.${this.id}`
    },

    maxLength() {
      return 200
    },

    priority() {
      return this.evaluation.title === 'requirements' ? 'max' : 'min'
    },

    tips() {
      return `evaluation.tips.${this.evaluation.title}.`
    },

    title() {
      return this.titles + this.id
    },

    titles() {
      return `evaluations.${this.evaluation.title}.titles.`
    },

    currentSection() {
      return this.entries[0]['children'][this.currentSectionIndex]
    },

    countSections() {
      return this.entries[0]['children'].length
    },

    progressBarWidth() {
      return 'width: ' + Math.floor((this.currentSectionIndex + 1) / this.countSections * 100) + '%;'
    },

    isSectionMasked(index) {
      return this.$refs.evaluation_section[index].wholeSectionMasked
    }
  },

  async created() {
    this.selection = this.data[0]
    this.selected = this.selection
    this.entries = this.$store.getters['evaluations/' + this.evaluation.title].entries
  },

  mounted() {
    // Initialize all popovers.
    $('[data-toggle="popover"]').popover()

    this.currentSectionIndex = 0
  },

  methods: {
    async c2method () {
      this.$emit('mymethode')



      // component('Evaluations').saveSnapshot(value)
    },

    formatDate (date) {
      if (date) {
        return Date.fromDateTime(date).toUserLocaleString(this)
      }
      return ''
    },

    okWarningSnapshotModal () {
      this.closeWarningSnapshotModal()

      if (this.savingNew) {
        this.saveAs()
      } else {
        this.save()
      }
    },
    // saveAs () {
    //   this.resetForm()
    //   this.$refs.saveSnapshotModal.show()
    // },
    beforeSaveAs(){

       // this.resetForm()
        this.$refs.saveSnapshotModal.show()
    },
    resetForm () {
      this.form.id = 0
      this.form.mask_id = null
      this.form.recipient_id = 0
      this.form.title = ''
      this.form.comments = ''
      this.form.contributors = []
    },
    // beforeSaveAs () {
    //   this.savingNew = true
    //
    //   if (!this.$refs.evaluation[this.currentTab].validate()) {
    //     this.$refs.warningSnapshotModal.show()
    //   } else {
    //     this.saveAs()
    //   }
    // },
    setLatestClick(i) {
      this.latestClick = i
    },

    nextSection() {
      if (this.currentSectionIndex < this.countSections - 1) {
        this.currentSectionIndex++;
        if (this.currentSectionIndex == 1) {
          this.apend_s1 = true;
        } else if (this.currentSectionIndex == 9) {
          this.apend_s9 = true;
        }else if (this.currentSectionIndex == 10){
          this.apend_s9 = false;
            this.apend_btn = true;
          }
         else {
          this.apend_s1 = false;
          this.apend_s9 = false;
          this.apend_btn=false;
        }
      }
    },
    previousSection() {
      if (this.currentSectionIndex > 0) {
        this.currentSectionIndex--;
        if (this.currentSectionIndex == 1) {
          this.apend_s1 = true;
        } else if (this.currentSectionIndex == 9) {
          this.apend_s9 = true;
        } else {
          this.apend_s1 = false;
          this.apend_s9 = false;
        }
      }
    },

    changeSection() {
      this.$refs.sectionNotFull.hide()
      window.scrollTo(0, 0)
      if (this.latestClick === 0) {
        this.previousSection();
      } else {
        this.nextSection();
      }
    },


    validateSection(i) {
      this.setLatestClick(i)
      if (!this.$refs.evaluation_sections[this.currentSectionIndex].validate()) {
        this.$refs.sectionNotFull.show()
      } else {
        this.changeSection()
      }
    },

    validate() {
      let success = true
      for (let index in this.$refs.evaluation_sections) {
        if (typeof this.$refs.evaluation_sections[index].$data !== 'undefined') {
          if (!this.$refs.evaluation_sections[index].wholeSectionMasked()) {
            success = this.$refs.evaluation_sections[index].validate() && success
          }
        }
      }
      return success
    },

    setSnapshot(snapshot) {
      for (let i = 0; i < this.evaluation.data[0].children.length; i++) {
        this.$refs.evaluation_sections[i].setSnapshot(snapshot[i])
      }
    },

    $_getSnapshot(node, list, valueToIgnore) {
      if (node.children.length == 0) {
        let sublist = []

        if (node.value != null && (node.value != valueToIgnore || node.comment)) {
          sublist.push(node.value)
        }

        if (node.comment) {
          sublist.push(node.comment)
        }

        list.push(sublist)
      } else {
        for (let i = 0; i < node.children.length; i++) {
          this.$_getSnapshot(node.children[i], list, valueToIgnore)
        }
      }

      return list
    },

    getSnapshot() {
      let snapshot = []
      for (let index in this.$refs.evaluation_sections) {
        if (typeof this.$refs.evaluation_sections[index].$data !== 'undefined') {
          snapshot[index] = JSON.parse(JSON.stringify(this.$refs.evaluation_sections[index].$data))
        }
      }
      return snapshot
    },

    onSelectionFromLeft(item) {
      this.setInfosFromItem(item)

      // Set current node to selected node.
      // If node is a leaf, get its parent.
      this.selection = item
      if (!item.hasChildren) {
        this.selection = item.$parent
      }
    },

    onSelectionFromRight(item) {
      this.setInfosFromItem(item)
    },

    /**
     * Show name and desription of node in header.
     *
     * @var Item Node to show.
     */
    setInfosFromItem(item) {
      this.id = item.data.id
      this.selected = item

      // If node is a leaf and hasn't a comment yet, make one.
      if (!item.hasChildren && !this.selected.data.comment) {
        Vue.set(this.selected.data, 'comment', '')
      }
    },

    update() {
      for (let index in this.$refs.evaluation_sections) {
        if (typeof this.$refs.evaluation_sections[index].$data !== 'undefined') {
          this.$refs.evaluation_sections[index].update()
        }
      }
    },

    reset() {
      for (let index in this.$refs.evaluation_sections) {
        if (typeof this.$refs.evaluation_sections[index].$data !== 'undefined') {
          this.$refs.evaluation_sections[index].reset()
        }
      }
    },

    closeModalSectionNotFull() {
      this.$refs.sectionNotFull.hide()
    },

    clearErrors(i) {
      this.$refs.evaluation_sections[i].clearErrors()
    }
  }
}
</script>

<style scoped>
textarea {
  height: 5rem;
  resize: none;
}

.informations h5 {
  margin-bottom: 1rem;
}

.row {
  margin-bottom: 40px;
}

.progress {
  border: 0;
  height: 30px;
  border-radius: 20px;
  margin-bottom: 20px;
}

.progress::-webkit-progress-bar {
  border: 0;
  height: 30px;
  border-radius: 20px;
}

.progress::-webkit-progress-value {
  border: 0;
  height: 30px;
  border-radius: 20px;
}

.progress::-moz-progress-bar {
  border: 0;
  height: 30px;
  border-radius: 20px;
}

.progressBottom {
  width: 100%;
}
.comSize {
  font-size : 17px;
  font-weight: bold;
}
hr
{
  display: inline-block;
  width: 100%;
}
.comSize {
  font-size : 17px;
  font-weight: bold;
}
hr
{
  display: inline-block;
  width: 100%;
}
a{
  color: #000000;
  text-decoration: underline;
}
@media only screen and (min-width: 375px) and (max-width: 425px) {
  .position-btn {
    position: relative;
    top: -54px;
    right: 48px;
  }

  .position-link {
    position: relative;
    top: -33px;
    right: -211px;
  }
}
@media only screen and (min-width: 426px) and (max-width: 439px) {
  .position-btn {
    position: relative;
    top: -48px;
    right: 75px;
  }

  .position-link {
    position: relative;
    top: -32px;
    right: -184px;
  }
}
@media only screen and (min-width: 440px) and (max-width: 548px) {
  .position-btn {
    position: relative;
    top: -76px;
    right: -96px;
  }

  .position-link {
    position: relative;
    top: -79px;
    right: -184px;
  }
}
@media only screen and (min-width: 549px) and (max-width: 767px) {
  .position-btn {
    position: relative;
    top: -78px;
    right: -177px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px){
  .position-btn{
    position: relative;
    top: -77px;
    right: -30px;
  }
  .position-link{
    position: relative;
    top: 5px;
    right: -126px;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1440px){
  .position-btn {
    position: relative;
    top: -77px;
    right: 144px;
  }
  .position-link {
    position: relative;
    top: 3px;
    right: -41px;
  }
}
@media only screen and (min-width: 1441px) and (max-width: 2560px){
  .position-btn {
    position: relative;
    top: -77px;
    right: 422px;
  }
  .position-link {
    position: relative;
    top: 3px;
    right: -41px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/EvaluationX.vue